import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

const Test = (props) => {
  const { lesson, handleLessonCompletion, isLastLesson } = props;
  const totalQuestions = lesson.questions.length;

  const question = () => {
    return lesson.questions[currentQuestion];
  };

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [currentAnswers, setCurrentAnswers] = useState([]);
  const [selectedAnswers, setSelectedAnswers] = useState({});

  useEffect(() => {
    setCurrentAnswers(
      selectedAnswers[lesson.questions[currentQuestion].id] || [],
    );
  }, [currentQuestion]);

  const handleAnswerChange = (answerId) => {
    let answers;

    if (currentAnswers.includes(answerId)) {
      answers = currentAnswers.filter((id) => id !== answerId);
    } else {
      answers = [...currentAnswers, answerId];
    }

    selectedAnswers[lesson.questions[currentQuestion].id] = answers;
    setCurrentAnswers(answers);
    setSelectedAnswers({ ...selectedAnswers });
  };

  const handlePrevQuestion = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  const handleNextQuestion = async () => {
    if (currentQuestion < lesson.questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      await handleLessonCompletion({ answers: selectedAnswers });
    }
  };

  const progressPercentage = () => {
    return ((currentQuestion + 1) / totalQuestions) * 100;
  };

  return (
    <>
      <div className="bg-white border p-6 shadow-sm">
        <div className="mb-6">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm">Pytanie {currentQuestion + 1}</span>
            <span className="text-xs text-gray-400">
              {progressPercentage()}%
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2 mb-6">
            <div
              className="bg-black h-2 rounded-full transition-all duration-300 ease-in-out"
              style={{ width: `${progressPercentage()}%` }}
            ></div>
          </div>
          <h1 className="text-lg font-semibold text-gray-900">
            {question().content}
          </h1>
        </div>

        {/* Answers */}
        <div className="space-y-3 mb-6">
          {question().answers.map((answer) => {
            return (
              <div
                key={answer.id}
                className={`
                  flex items-center space-x-3 p-3 border cursor-pointer transition-colors
                `}
                onClick={() => handleAnswerChange(answer.id)}
              >
                <input
                  type="checkbox"
                  className="accent-black"
                  checked={currentAnswers.includes(answer.id)}
                  onChange={() => {}}
                />
                <label className="flex-1 cursor-pointer text-sm">
                  {answer.content}
                </label>
              </div>
            );
          })}
        </div>

        {/* Action buttons */}
        <div className="flex justify-between items-center">
          <button
            onClick={handlePrevQuestion}
            disabled={currentQuestion === 0}
            className="
              px-6 py-2 bg-black text-white text-sm
              hover:bg-primaryYellow
              disabled:bg-white disabled:text-primaryYellow
              disabled: border-primaryYellow disabled:border
              enabled:cursor-pointer
              transition-colors
            "
          >
            Poprzednie pytanie
          </button>

          <button
            onClick={handleNextQuestion}
            disabled={currentAnswers.length === 0}
            className="
              px-6 py-2 bg-black text-white text-sm
              hover:bg-primaryYellow
              disabled:bg-gray-200 disabled:text-gray-400
              enabled:cursor-pointer
              transition-colors
            "
          >
            {currentQuestion < lesson.questions.length - 1
              ? "Następne pytanie"
              : isLastLesson
                ? "Zakończ kurs"
                : "Zakończ test"}
          </button>
        </div>
      </div>
    </>
  );
};

Test.propTypes = {
  lesson: PropTypes.object,
  handleLessonCompletion: PropTypes.func,
  isLastLesson: PropTypes.bool,
};

export default Test;
